export const CardStyle = {
  wrapperBox: {
    flex: 1,
    display: "flex",
  },
  wrapperPaper: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  content: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    height: "100%",
  },
  input: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignText: "center",
    paddingX: "8px",
  },
  text: { paddingLeft: "8px", whiteSpace: "pre", },
  textInside: { paddingLeft: "8px", whiteSpace: "pre", fontSize: "30px" },
  icon: {
    paddingRight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  iconMainBox: {
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "row",
    alignItems: "center"
  },
  iconIsideBox: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",

  }
};
